var map = {
	"./LandingAboutMobile.svg": 941,
	"./LandingGalleryPage.svg": 151,
	"./landingAboutUs.svg": 243,
	"./landingGallery.svg": 122,
	"./landingHome.svg": 957,
	"./landingService.svg": 534,
	"./landingServicePage.svg": 408,
	"./landingpagemobile.svg": 39
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 937;